var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',[_c('v-chart',{ref:"bar",staticClass:"cischart",attrs:{"options":_vm.barOption,"auto-resize":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }